<template>
  <div class="view">
    <Title title="イベント"/>
    <EventNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventNewMain from '@/components/Event/NewMain'

export default {
  components: {
    Title,
    EventNewMain
  }
}
</script>
